export const APP_LOADED_SUCCESS = 'APP/APP_LOADED_SUCCESS';

export const ERROR = 'APP/ERROR';
export const CLEAR_ERRORS = 'APP/CLEAR_ERRORS';
